import { api } from 'api';
import { checkMaintenance } from 'helpers/maintenance';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import useStore from './useStore';

const useCountryConfig = (countryCode, prevCountryConfig) => {
  const { state } = useStore();
  const { currentReceiver } = state;

  const [countryConfig, setCountryConfig] = useState(null);

  const fetchCountryConfig = async (countryCode) => {
    try {
      const { data } = await api.getCountryConfig(countryCode);
      setCountryConfig(data);
    } catch (error) {
      checkMaintenance(error);
      console.error(error?.message);
    }
  };

  useEffect(() => {
    if (
      !isEmpty(currentReceiver) &&
      !isEmpty(prevCountryConfig) &&
      currentReceiver?.country?.code === prevCountryConfig?.countryCode
    ) {
      setCountryConfig(prevCountryConfig);
      return;
    }

    if (!isEmpty(currentReceiver) && currentReceiver?.country?.code) {
      fetchCountryConfig(currentReceiver?.country?.code);
      return;
    }

    if (countryCode) {
      fetchCountryConfig(countryCode);
    }
  }, [countryCode, currentReceiver, prevCountryConfig]);

  return countryConfig;
};

export default useCountryConfig;
